import React, { Component } from "react";
import { Collapse, Card } from "reactstrap";
import AboutList from "../../library/baaShared/AboutList";
import "./LeftNavigation.scss";
import Arrow from "../../assets/sand-arrow1.png";
import dictionary from "i18next";

export default class LeftNavigation extends Component {
  constructor(props) {
    super(props);
    this.toggle = this.toggle.bind(this);
    this.state = { collapse: false };
  }

  toggle() {
    this.setState(state => ({ collapse: !state.collapse }));
  }
  render() {
    const { fields } = this.props;
    let aboutList = fields && fields.items ? fields.items : [];
    return (
      <React.Fragment>
        <section className="leftNavagation-wrapper">
          {aboutList.length > 0 ? <AboutList aboutListData={aboutList} mobile={false} /> : ""}
        </section>

        <section className="leftnavigation-wrapper-mobile">
          <div className="leftNav-mobile" onClick={this.toggle}>
            {dictionary.t("Common-JumpTo", "JUMP TO")}
            <div className="article-dropdown-arrow">
              <img
                src={Arrow}
                className={this.state.collapse ? "arrow-down" : "arrow-up"}
                alt="Arrow"
              />
            </div>
          </div>
        </section>
        <Collapse isOpen={this.state.collapse} className="leftNav-mobile">
          <div className="card-body">
            {aboutList.length > 0 ? (
              <AboutList aboutListData={aboutList} mobile={true} />
            ) : (
                ""
              )}
          </div>
        </Collapse>
      </React.Fragment>
    );
  }
}
